import React from 'react';
import { CopyableBlock } from '../CopyableBlock';

const RadioVariant = ({ label, variant, idPrefix }) => {
  if (!variant) return null;
  const composed = [
    variant.host_intro && `[HOST INTRO]\n${variant.host_intro}`,
    variant.youth_story && `[YOUTH STORY]\n${variant.youth_story}`,
    variant.key_learning && `[KEY LEARNING]\n${variant.key_learning}`,
    variant.host_close && `[HOST CLOSE]\n${variant.host_close}`,
  ].filter(Boolean).join('\n\n');
  return (
    <div className="mb-5 pb-5 border-b border-gray-100 last:border-0">
      <h4 className="text-sm font-bold text-gray-900 mb-3">{label}</h4>
      <CopyableBlock label="Host Intro" content={variant.host_intro} testId={`${idPrefix}-intro`} />
      <CopyableBlock label="Youth Story" content={variant.youth_story} testId={`${idPrefix}-story`} />
      <CopyableBlock label="Key Learning" content={variant.key_learning} testId={`${idPrefix}-learning`} />
      <CopyableBlock label="Host Close" content={variant.host_close} testId={`${idPrefix}-close`} />
      <CopyableBlock label="Full Script" content={composed} mono testId={`${idPrefix}-full`} />
    </div>
  );
};

export const RadioOutputs = ({ data }) => {
  if (!data) return null;
  return (
    <div data-testid="output-radio">
      <RadioVariant label="30-second version" variant={data.thirty_second} idPrefix="r30" />
      <RadioVariant label="60-second version" variant={data.sixty_second} idPrefix="r60" />
      <RadioVariant label="2-minute version" variant={data.two_minute} idPrefix="r120" />
    </div>
  );
};

export default RadioOutputs;
